<template>
  <header class="header">
    <div class="webHeaderMainLogo">
        <img @click.prevent="goHome()" type="submit" src="../../assets/Logo2.png" alt="logo de Privilégia Coiffure">
    </div>

    <div class="webHeaderMainNavbar">
      <nav>
        <div>
          <ul>
            <li><a>Privilégia</a>
              <ul>
                <li><a @click.prevent="goConcept()">Qui suis-je?</a></li>
                <li><a @click.prevent="goPresse()">Presse</a></li>
                <li><a @click.prevent="goAvis()">Laisser un avis</a></li>
              </ul>
            </li>
            <li><a>Prestations</a>
              <ul>
                <li><a @click.prevent="goFemmes()">Femmes</a></li>
                <li><a @click.prevent="goHommes()">Hommes</a></li>
                <li><a @click.prevent="goEnfants()">Enfants</a></li>
                <li><a @click.prevent="goSoins()">Soins énergétiques</a></li>
              </ul>
            </li>
            <li><a @click.prevent="goArticles()" type="submit">Actualités</a></li>
          </ul>
        </div>
      </nav>
    </div>

  </header>
</template>

<script>
export default {
  name: 'HeaderWeb',
  data () {
    return {
    }
  },
  methods: {
    goHome () {
      this.$router.push('/')
    },
    goConcept () {
      this.$router.push('/Concept')
    },
    goPresse () {
      this.$router.push('/Presse')
    },
    goAvis () {
      document.location.href = 'https://g.page/r/CcOTSr84BpMyEBM/review'
    },
    goFemmes () {
      this.$router.push('/Tarifs/Femmes')
    },
    goHommes () {
      this.$router.push('/Tarifs/Hommes')
    },
    goEnfants () {
      this.$router.push('/Tarifs/Enfants')
    },
    goSoins () {
      this.$router.push('/Tarifs/Soins-Energetiques')
    },
    goArticles () {
      this.$router.push('/Articles')
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/SiteWeb/Header.vue